// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginSignUpFlow_container__oS7h7","header":"LoginSignUpFlow_header__YpvE5","form":"LoginSignUpFlow_form___k27B","terms":"LoginSignUpFlow_terms__sNjbL"};